<template>
  <div class="content">
    <div class="md-layout">
       <FilterCliente :onChange="changeFilter"/>
       <GraphicVersoesSistemas :style="verisonSistemaZI ? 'z-index: 1' :'z-index: 0' " @click.native="verisonSistemaEV" :atividades="selectAtv" :personas="selectPrs" :analistas="selectAnl" :arquivos="selectArq" />
       <GraphicVersoesEMS  :style="verisonEMSZI ? 'z-index: 1' :'z-index: 0' " @click.native="verisonEMSEV" :atividades="selectAtv" :personas="selectPrs" :analistas="selectAnl" :arquivos="selectArq" />
 
      <div style="width: 100%;">
        <GmapMap
          ref="mapRef"
          :options="mapStylee"
          :center="{lat:-19.3131256, lng:-46.0670008}"
          style="width: 100%;height: 450px;"
        >
          <GmapMarker
            ref="myMarker"
            @click="center={lat:-19.3131256, lng:-46.0670008}"
            :position="google && new google.maps.LatLng(-19.3131256, -46.0670008)"
          />
        </GmapMap>
      </div>
     
    </div>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import GraphicVersoesSistemas from "../components/Dashboard/graphicVersoesSistemas"
import GraphicVersoesEMS from "../components/Dashboard/graphicVersoesEMS"
import FilterCliente from "../components/Common/FilterCliente"
//import * as ClientesService from "../providers/clientes.service";

export default {
  components: {
    GraphicVersoesSistemas,
    GraphicVersoesEMS,
    FilterCliente
  },
  computed: {
    google: gmapApi
  },
 
  data() {
    var self = this;
    return {
      verisonSistemaZI: false,
      verisonEMSZI: false,
      mapStylee: {
        disableDefaultUI: true,
        language: "br",
        zoom: 14,
        styles: require("../assets/mapBlack.json")
      },
      selectAtv: [],
      selectPrs: [],
      selectAnl: [],
      selectArq: []
    };
  },

  methods: {
    verisonSistemaEV(ev){
      this.verisonSistemaZI = true
      this.verisonEMSZI = false
    },
     verisonEMSEV(ev){
      this.verisonSistemaZI = false
      this.verisonEMSZI = true
    },
    getUserData() {
      var self = this;
      var user = new Object();
      self.$getLocation().then(coordinates => {
        //console.log(coordinates);
        user.latitude = coordinates.lat;
        user.longitude = coordinates.lng;
      });
    },
    changeFilter(selectAtv, selectPrs, selectAnl, selectArq) {
      this.selectAtv = selectAtv; 
      this.selectPrs = selectPrs;
      this.selectAnl = selectAnl;
      this.selectArq = selectArq;
    }
  }
};
</script>
<style scoped>
.md-tabs-navigation {
  padding-left: 200px !important;
}
.md-card .md-tabs.md-success .md-tabs-navigation {
  padding-left: 139px !important;
}
</style>

